"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizQuestionFromJSON = QuizQuestionFromJSON;
exports.QuizQuestionFromJSONTyped = QuizQuestionFromJSONTyped;
exports.QuizQuestionToJSON = QuizQuestionToJSON;
exports.QuizQuestionToJSONTyped = QuizQuestionToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function QuizQuestionFromJSON(json) {
    return QuizQuestionFromJSONTyped(json, false);
}
function QuizQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'quizId': !(0, runtime_1.exists)(json, 'quizId') ? undefined : json['quizId'],
        'question': !(0, runtime_1.exists)(json, 'question') ? undefined : json['question'],
        'lead': !(0, runtime_1.exists)(json, 'lead') ? undefined : json['lead'],
        'body': !(0, runtime_1.exists)(json, 'body') ? undefined : json['body'],
        'sequenceNr': !(0, runtime_1.exists)(json, 'sequenceNr') ? undefined : json['sequenceNr'],
        'imageId': !(0, runtime_1.exists)(json, 'imageId') ? undefined : json['imageId'],
        'archive': !(0, runtime_1.exists)(json, 'archive') ? undefined : json['archive'],
        'imageUrls': !(0, runtime_1.exists)(json, 'imageUrls') ? undefined : (0, _1.ImageUrlsFromJSON)(json['imageUrls']),
        'answers': !(0, runtime_1.exists)(json, 'answers') ? undefined : (json['answers'].map(_1.QuizAnswerFromJSON)),
    };
}
function QuizQuestionToJSON(value) {
    return QuizQuestionToJSONTyped(value, false);
}
function QuizQuestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'quizId': value.quizId,
        'question': value.question,
        'lead': value.lead,
        'body': value.body,
        'sequenceNr': value.sequenceNr,
        'imageId': value.imageId,
        'archive': value.archive,
        'imageUrls': (0, _1.ImageUrlsToJSON)(value.imageUrls),
        'answers': value.answers === undefined ? undefined : (value.answers.map(_1.QuizAnswerToJSON)),
    };
}
